function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// CONFIG
var maxHistorylength = 24;
var expiration = 60; // Days;

var storageKey = 'historyNavigation';
var separator = ',';
var NavigationHistory = /*#__PURE__*/function () {
  function NavigationHistory() {
    _classCallCheck(this, NavigationHistory);
    this.currentRef = document.querySelector('.js-product-ref') && document.querySelector('.js-product-ref').innerText;
    if (this.currentRef) {
      lm.localStorageLM.init();
      this.save();
    }
  }
  return _createClass(NavigationHistory, [{
    key: "save",
    value: function save() {
      var currentHistory = lm.localStorageLM.get(storageKey).split(separator).filter(function (ref) {
        return ref !== '';
      });

      // remove doublons
      var existingRefIndex = currentHistory.indexOf(this.currentRef);
      if (existingRefIndex >= 0) {
        currentHistory.splice(existingRefIndex, 1);
      }

      // Remove oldest refs if history is full
      if (currentHistory.length >= maxHistorylength) {
        currentHistory.pop();
      }
      currentHistory.unshift(this.currentRef);
      var newHistory = currentHistory.join(separator);
      lm.localStorageLM.set(storageKey, newHistory, expiration);
    }
  }]);
}();
export { NavigationHistory as default };